const data = {
  reliableIncome:
    'Over 10,000 people sign up on BetterHelp every day looking for a counselor to help with lifes challenges. BetterHelp can be your main source of income or a supplement to your current work.',
  focusonCounseling:
    'Over 10,000 people sign up on BetterHelp every day looking for a counselor to help with lifes challenges. BetterHelp can be your main source of income or a supplement to your current work.',
};
export { data };
